// Color palette based on HansCard logo
export const colors = {
  // Primary brand color (dark purple from logo)
  primary: {
    50: '#EAEAF0',
    100: '#D4D4E0',
    200: '#AAABC1',
    300: '#8082A7',
    400: '#5F628E',
    500: '#464474', // Main purple from logo
    600: '#3A3960',
    700: '#2E2E4C',
    800: '#222239',
    900: '#161725',
  },
  // Secondary colors
  secondary: {
    50: '#F8F8F8',
    100: '#F0F0F0',
    200: '#E6E6E6',
    300: '#D1D1D1',
    400: '#ABABAB',
    500: '#9E9E9E',
    600: '#7E7E7E',
    700: '#626262',
    800: '#515151',
    900: '#3B3B3B',
  },
  // Accent colors for highlights
  accent: {
    blue: '#578DEA',
    purple: '#9062EA',
    green: '#56C288',
    yellow: '#EABC56',
    red: '#E05D5D',
  }
};

// Export color theme according to color mode
export const getThemeColors = (colorMode: 'light' | 'dark') => {
  return {
    bg: {
      primary: colorMode === 'dark' ? colors.primary[800] : 'white',
      secondary: colorMode === 'dark' ? colors.primary[700] : colors.secondary[50],
      tertiary: colorMode === 'dark' ? colors.primary[600] : colors.secondary[100],
    },
    text: {
      primary: colorMode === 'dark' ? 'white' : colors.primary[900],
      secondary: colorMode === 'dark' ? colors.secondary[300] : colors.primary[600],
      accent: colorMode === 'dark' ? colors.primary[300] : colors.primary[500],
    },
    border: {
      light: colorMode === 'dark' ? colors.primary[600] : colors.secondary[200],
      medium: colorMode === 'dark' ? colors.primary[500] : colors.secondary[300],
      dark: colorMode === 'dark' ? colors.primary[400] : colors.secondary[400],
    },
    button: {
      primary: colors.primary[500],
      primaryHover: colors.primary[600],
      secondary: colorMode === 'dark' ? colors.primary[600] : colors.secondary[100],
      secondaryHover: colorMode === 'dark' ? colors.primary[500] : colors.secondary[200],
    }
  };
};